export * from './ui';
export * from './translation';
export * from './forum';
export * from './braze';
export * from './inbox-notification';
export * from './home';
export * from './abtest';
export const USER_STATUS_ACTIVE = 0;
export const USER_STATUS_MEMBER_DELETED = 3;
export const USER_STATUS_BANNED = 8;
export const USER_STATUS_ACTIVE_UNCONFIRMED = 9;
export const USER_STATUS_TEMPORARY = 13;
export const USER_STATUS_TEMPORARY_UNCONFIRMED = 14;
export const VERIFICATION_LIST = ['facebook', 'google', 'email'];
export const CLOSET_PROMOTIONS_COUNT = 4;
export const CLOSET_PROMOTIONS_ITEM_COUNT = 5;
export const DEFAULT_PAGE_SIZE = 20;
export const INITIAL_PAGE = 1;
export const TRANSLATION = Object.freeze({
  AUTO: 'auto',
  MANUAL: 'manual',
  NONE: 'none'
});
export const SEARCH_SUGGESTION_FALLBACK_ID = -1;
export const SEARCH_SUGGESTION_MIN_QUERY_LENGTH = 1;
export let AccessChannel;

(function (AccessChannel) {
  AccessChannel["VintedGuide"] = "vinted_guide";
  AccessChannel["HcSearch"] = "hc_search";
  AccessChannel["HcTransaction"] = "hc_transaction";
  AccessChannel["HcTopics"] = "hc_topics";
  AccessChannel["ConversationTx"] = "conversation_tx";
  AccessChannel["ConversationNoTx"] = "conversation_no";
  AccessChannel["ProductLink"] = "product_link";
  AccessChannel["ExternalLink"] = "external_link";
  AccessChannel["DataExport"] = "data_export";
})(AccessChannel || (AccessChannel = {}));

export let InternationalTradingAbTest;

(function (InternationalTradingAbTest) {
  InternationalTradingAbTest["Control"] = "c";
  InternationalTradingAbTest["InitiallyEnabled"] = "on";
  InternationalTradingAbTest["InitiallyDisabled"] = "off";
})(InternationalTradingAbTest || (InternationalTradingAbTest = {}));

export const CDN_ASSETS_URL = 'https://vinted-core-assets.s3.eu-central-1.amazonaws.com';
export const CDN_IMAGES_URL = "".concat(CDN_ASSETS_URL, "/images");
export const CDN_ADS_URL = "".concat(CDN_ASSETS_URL, "/ads");
export const CDN_SHIPPING_DIRECTORY = 'shipping';
export const CDN_SHIPPING_TRACKING_ASSETS_URL = "".concat(CDN_ASSETS_URL, "/").concat(CDN_SHIPPING_DIRECTORY, "/tracking/tracking_code_");
export const STATIC_ASSETS_URL = 'https://static.vinted.com';
export const TWO_FA_CANCELLED_EVENT = 'twoFACancelled';
export const TWO_FA_COMPLETED_EVENT = 'twoFACompleted';
export let TransparencyLawSubject;

(function (TransparencyLawSubject) {
  TransparencyLawSubject["BuyerRights"] = "buyerRights";
  TransparencyLawSubject["ProfessionalSeller"] = "professionalSeller";
})(TransparencyLawSubject || (TransparencyLawSubject = {}));

export let PromoBoxBlockName;

(function (PromoBoxBlockName) {
  PromoBoxBlockName["RecentlyFavouritedItems"] = "favourites";
  PromoBoxBlockName["PopularItems"] = "popular_items";
  PromoBoxBlockName["ItemsBasedOnRecentPurchases"] = "recent_purchases_by_brand";
  PromoBoxBlockName["RecommendedItems"] = "recommended_items";
  PromoBoxBlockName["GenericItemsBlock"] = "blocks";
})(PromoBoxBlockName || (PromoBoxBlockName = {}));

export let PromoBoxType;

(function (PromoBoxType) {
  PromoBoxType[PromoBoxType["Vinted"] = 0] = "Vinted";
  PromoBoxType[PromoBoxType["Braze"] = 1] = "Braze";
  PromoBoxType[PromoBoxType["BrazeSticky"] = 2] = "BrazeSticky";
})(PromoBoxType || (PromoBoxType = {}));